import { money } from 'services/graphql/fragments/Fragments';
import { AnalyticsFragment } from 'services/graphql/fragments/VxlFragments';
import { gql } from 'urql';

const applePayFundingOptions = gql`
  query ApplePayFundingOptions {
    applePayFundingOptions {
      __typename
      ... on ApplePayFundingOptionsSuccess {
        minAmount {
          ...money
        }
        maxAmount {
          ...money
        }
        limitInfo
        transferLimitErrorMessage
        options {
          title
          amount {
            ...money
          }
        }
        cardNetworks
        merchantCapabilities
        dailyLimitInformation {
          title
          message1
          message2
        }
        monthlyLimitInformation {
          title
          message1
          message2
        }
        disclaimer
      }
      ... on ApplePayFundingOptionsNotEligible {
        title
        message
        button {
          id
          buttonText
          buttonStyle
          buttonOnClick {
            __typename
            ... on SDBackNavigationAction {
              # TODO(JT-145378): Wire up analyticsEvent for back navigation tracking
              analyticsEvent {
                ...analytics
              }
            }
          }
        }
      }
      ... on ApplePayFundingOptionsError {
        title
        message
      }
    }
  }
  ${money}
  ${AnalyticsFragment}
`;

export default applePayFundingOptions;
